// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CaregiverPopup-module__grid___UauQx {
  display: grid;
  padding: 25px 30px;
  grid-row-gap: 25px;
  grid-column-gap: 25px;
  grid-template-columns: repeat(3, 1fr);
}
.CaregiverPopup-module__grid___UauQx .CaregiverPopup-module__width75___Uv9DO {
  grid-column: 2 span;
}

.CaregiverPopup-module__buttonsContainer___s5d1C {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
  justify-content: end;
  padding: 30px;
  display: flex;
  gap: 16px;
}

.CaregiverPopup-module__phoneInput___hughk > div {
  overflow: hidden;
}
.CaregiverPopup-module__phoneInput___hughk input {
  box-sizing: border-box;
}`, "",{"version":3,"sources":["webpack://./src/popups/CaregiverPopup/CaregiverPopup.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qCAAA;AACF;AACE;EACE,mBAAA;AACJ;;AAGA;EACE,2CAAA;EACA,oBAAA;EACA,aAAA;EACA,aAAA;EACA,SAAA;AAAF;;AAIE;EACE,gBAAA;AADJ;AAIE;EACE,sBAAA;AAFJ","sourcesContent":[".grid {\n  display: grid;\n  padding: 25px 30px;\n  grid-row-gap: 25px;\n  grid-column-gap: 25px;\n  grid-template-columns: repeat(3, 1fr);\n\n  .width75 {\n    grid-column: 2 span;\n  }\n}\n\n.buttonsContainer {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n  justify-content: end;\n  padding: 30px;\n  display: flex;\n  gap: 16px;\n}\n\n.phoneInput {\n  & > div {\n    overflow: hidden;\n  }\n\n  input {\n    box-sizing: border-box;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid": `CaregiverPopup-module__grid___UauQx`,
	"width75": `CaregiverPopup-module__width75___Uv9DO`,
	"buttonsContainer": `CaregiverPopup-module__buttonsContainer___s5d1C`,
	"phoneInput": `CaregiverPopup-module__phoneInput___hughk`
};
module.exports = ___CSS_LOADER_EXPORT___;
